<template>
    <div class="px-4 rounded ">
        <b-card no-body class="shadow-sm rounded">
            <b-card-header class="bg-primary d-flex justify-content-between align-items-center rounded">
                <span class="mb-0 h5 text-white">
                    <i class="fas fa-history mr-2"></i> Registro de Cambios
                </span>
                <div>
                    <b-button variant="light" size="xl" class="mr-2" @click="toggleFilters">
                        <i class="fas fa-filter"></i>
                    </b-button>
                    <b-button variant="light" @click="verCambio">
                        <i :class="verCambios ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                    </b-button>
                </div>
            </b-card-header>

            <!-- Filtros -->
            <b-collapse v-model="showFilters" class="border-bottom">
                <b-card-body>
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Acción" label-for="filter-action">
                                <b-form-select id="filter-action" v-model="filters.accion"
                                    :options="['Todas', 'AÑADIDO', 'ACTUALIZADO', 'BORRADO']"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Tabla" label-for="filter-table">
                                <b-form-select id="filter-table" v-model="filters.tabla"
                                    :options="['Todas', ...getUniqueTables()]"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Fecha" label-for="filter-date">
                                <b-form-input id="filter-date" v-model="filters.fecha" type="date"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="text-right">
                        <b-button variant="outline-secondary" size="sm" @click="resetFilters" class="mr-2">
                            <i class="fas fa-undo"></i> Restablecer
                        </b-button>
                        <b-button variant="primary" size="sm" @click="applyFilters">
                            <i class="fas fa-search"></i> Aplicar
                        </b-button>
                    </div>
                </b-card-body>
            </b-collapse>

            <!-- Timeline de cambios -->
            <b-collapse v-model="verCambios">
                <b-card-body class="p-0  " style="height: 60vh; overflow-y:scroll">
                    <div class="timeline ">
                        <template v-if="filteredData.length > 0">
                            <div v-for="(item, index) in filteredData" :key="item.id" class="timeline-item">
                                <div class="timeline-badge" :class="getBadgeClass(item.accion)">
                                    <i :class="getBadgeIcon(item.accion)"></i>
                                </div>
                                <b-card class="timeline-card" :class="{
                                    'border-left-insert': item.accion === 'INSERT',
                                    'border-left-update': item.accion === 'UPDATE',
                                    'border-left-delete': item.accion === 'DELETE'
                                }">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <div class="d-flex flex-column col-5" style="overflow: hidden;">
                                            <h6 class="mb-1 " style="font-size: 1.5rem;">
                                                <span class="badge font-weight-bold"
                                                    :class="getBadgeVariant(item.accion)">{{ accionesHechas(item.accion)
                                                    }}</span>
                                            </h6>

                                            <span class="font-weight-bold h2">{{
                                                item.tablaAfectada.replace(/([a-z])([A-Z])/g, '$1 $2')
                                                }}</span>
                                            <p class="text-muted mb-2 small " style="font-size: 1rem;">
                                                <i class="far fa-clock mr-1 "></i> {{ formatDate(item.fechaCambios) }}
                                            </p>
                                        </div>
                                        <div class="d-flex flex-column col-6">
                                            <span class="font-weight-bold h3">Descripción cambio</span>
                                            <p>
                                                {{ item.descripcionCambios ? item.descripcionCambios :
                                                    'No se ha diligenciado ninguna descripción.' }}
                                            </p>
                                        </div>
                                        <div class="d-flex ">
                                            <vs-tooltip class="mr-4">
                                                <b-button variant=success
                                                    @click="abrirModalDescripcion(
                                                        item.id,
                                                        item.descripcionCambios ?
                                                            item.descripcionCambios : '')">
                                                    <i class="fa-solid fa-file-pen"></i>
                                                </b-button>
                                                <template #tooltip>
                                                    Añadir Descripción
                                                </template>
                                            </vs-tooltip>
                                            <b-button variant="link" class="p-0" @click="toggleDetails(index)">
                                                <i :class="item.showDetails ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                                                    class="text-white"></i>
                                            </b-button>
                                        </div>
                                    </div>

                                    <div class="d-flex" v-if="cambios.length > 0">
                                        <strong class="mr-2">Cambios:</strong>
                                        {{cambios[index]?.map(c =>
                                            c.columna.replace(/([a-z])([A-Z])/g, '$1 $2')).join(', ')
                                        }}
                                    </div>
                                    <b-collapse :id="`collapse-${index}`" v-model="item.showDetails">
                                        <hr class="my-2">
                                        <div class="change-details">
                                            <span class="mb-2 h3 font-weight-bold ">Detalles del cambio</span>
                                            <div v-if="cambios.length > 0" class="pt-2">
                                                <div v-for="(change, changeIndex) in cambios[index]" :key="changeIndex"
                                                    class="mb-2">
                                                    <div class="d-flex">
                                                        <div class="change-field font-weight-bold">{{
                                                            change.columna.replace(/([a-z])([A-Z])/g, '$1 $2') }}:
                                                        </div>
                                                        <div class="change-values ml-2">
                                                            <template
                                                                v-if="change.antes !== undefined && change.despues !== undefined">
                                                                <vs-tooltip>
                                                                    <div class="text-danger">
                                                                        <i class="fas fa-minus-circle mr-1"></i> {{
                                                                            change.antes
                                                                        }}
                                                                    </div>
                                                                    <template #tooltip>
                                                                        Valor anterior
                                                                    </template>
                                                                </vs-tooltip>
                                                                <vs-tooltip>
                                                                    <div class="text-success">
                                                                        <i class="fas fa-plus-circle mr-1"></i> {{
                                                                            change.despues }}
                                                                    </div>
                                                                    <template #tooltip>
                                                                        Valor actualizado
                                                                    </template>
                                                                </vs-tooltip>
                                                            </template>
                                                            <template v-else-if="change.antes !== undefined">
                                                                <vs-tooltip>
                                                                    <div class="text-danger">
                                                                        <i class="fas fa-minus-circle mr-1"></i> {{
                                                                            change.antes
                                                                        }}
                                                                    </div>
                                                                    <template #tooltip>
                                                                        Valor Eliminado
                                                                    </template>
                                                                </vs-tooltip>
                                                            </template>
                                                            <template v-else-if="change.despues !== undefined">
                                                                <vs-tooltip>
                                                                    <div class="text-success">
                                                                        <i class="fas fa-plus-circle mr-1"></i> {{
                                                                            change.despues
                                                                        }}
                                                                    </div>
                                                                    <template #tooltip>
                                                                        Valor Agregado
                                                                    </template>
                                                                </vs-tooltip>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="text-muted">
                                                No hay detalles disponibles
                                            </div>

                                            <div class="mt-3 pt-2 border-top">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <p class="mb-1  h3">
                                                            <strong>Usuario Editor:</strong> {{
                                                                item.nombreUsuarioEditor }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </template>
                        <div v-else class="text-center py-5">
                            <i class="fas fa-search fa-3x text-muted mb-3"></i>
                            <p class="text-muted">No se encontraron registros que coincidan con los filtros</p>
                        </div>
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-modal title="Añadir Descripción Cambios" id="modalDescripcionCambio" size="xl" hide-footer>
            <form @submit.prevent="guardarDescripcion">
                <div class="row mt-4 align-items-start">
                    <!-- Descripción de cambio realizado -->
                    <div class="col-xl-12 mb-3 ">
                        <label for="descripcionCambio" class="form-label">
                            Descripción de Ruta
                        </label>
                        <b-form-textarea v-model="descripcionCambio" id="descripcionCambio"
                            placeholder="Escriba una descripción..." rows="3" minlength="10" maxlength="550"
                            required></b-form-textarea>
                    </div>
                </div>
                <!-- Botón Guardar -->
                <div class="d-flex justify-content-end">
                    <vs-button type="submit" animation-type="vertical">
                        Añadir Descripción
                        <template #animate>
                            <i class="fas fa-plus-circle"></i>
                        </template>
                    </vs-button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name: 'RegistroCambiosPerfil',
    props: {
        datos: {
            type: Array,
            required: false
        }
    },
    watch: {
        datos: {
            immediate: true,
            async handler() {
                await this.ajustarInformacion(); // función que actualiza la vista interna
            }
        }
    },
    data() {
        return {
            showFilters: false,
            filters: {
                accion: 'Todas',
                tabla: 'Todas',
                fecha: ''
            },
            appliedFilters: {
                accion: 'Todas',
                tabla: 'Todas',
                fecha: ''
            },
            localData: [],
            cambios: [],
            verCambios: false,
            descripcionCambio: null,
            idCambio: null
        }
    },
    computed: {
        filteredData() {
            let result = this.localData;

            if (this.appliedFilters.accion !== 'Todas') {
                result = result.filter(item => item.accion === this.appliedFilters.accion);
            }

            if (this.appliedFilters.tabla !== 'Todas') {
                result = result.filter(item => item.tablaAfectada === this.appliedFilters.tabla);
            }

            if (this.appliedFilters.fecha) {
                const filterDate = new Date(this.appliedFilters.fecha);
                filterDate.setHours(0, 0, 0, 0);

                result = result.filter(item => {
                    const itemDate = new Date(item.fechaCambios);
                    itemDate.setHours(0, 0, 0, 0);
                    return itemDate.getTime() === filterDate.getTime();
                });
            }



            return result;
        }
    },
    async created() {
        // Inicializar datos locales con la propiedad showDetails
        await this.ajustarInformacion();
        //console.log("Los cambios son los siguientes", this.cambios);

    },
    methods: {
        async ajustarInformacion() {
            this.localData = this.datos.map(item => ({
                ...item,
                showDetails: false
            }));

            // Ordenar por fecha (más reciente primero)
            this.localData.sort((a, b) => {
                return new Date(b.fechaCambios) - new Date(a.fechaCambios);
            });

            this.localData = await Promise.all(
                this.localData.map(async obj => {
                    const persona = await this.obtenerPersona(obj.idUsuarioEditor);
                    return {
                        ...obj,
                        nombreUsuarioEditor: persona,
                    };
                })
            );


            for (let key in this.localData) {
                let cambios = this.localData[key].cambios;
                try {
                    let datosParseados = JSON.parse(cambios);
                    //console.log("Los datos parseados son: ", datosParseados);

                    // Filtrar los cambios no deseados
                    let filtrados = datosParseados.filter(item =>
                        item.columna !== 'PerfilCargoId' &&
                        item.columna !== 'CargoCritico' &&
                        item.columna !== 'TituloId' &&
                        item.columna !== 'FuncionId' &&
                        item.columna !== 'cargoId' &&
                        item.columna !== 'CargoId'
                    );

                    let cambiarDatos = await Promise.all(
                        filtrados.map(async obj => {
                            if (obj.columna === 'CompetenciaId') {
                                const competencia = await this.obtenerCompetenciaId(obj.despues || obj.antes);
                                let cambio = obj.despues ? 'despues' : 'antes'

                                return {
                                    ...obj,
                                    columna: 'Competencia',
                                    [cambio]: competencia
                                };
                            } else {
                                return obj;
                            }

                        })
                    );
                    console.log("cambiar Datos", cambiarDatos);



                    this.cambios.push(cambiarDatos)
                } catch (error) {
                    console.error("Error al parsear cambios:", error);
                }
            }
        },

        verCambio() {
            this.verCambios = !this.verCambios;
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        resetFilters() {
            this.filters = {
                accion: 'Todas',
                tabla: 'Todas',
                fecha: ''
            };
        },

        applyFilters() {
            this.appliedFilters = { ...this.filters };
        },

        getUniqueTables() {
            const tables = this.localData.map(item => item.tablaAfectada);
            return [...new Set(tables)];
        },

        toggleDetails(index) {
            this.$set(this.localData[index], 'showDetails', !this.localData[index].showDetails);
        },

        formatDate(dateString) {
            if (!dateString) return 'N/A';

            const date = new Date(dateString);
            return date.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },

        async obtenerPersona(id) {
            let respuesta = await this.$store.dispatch("hl_get", {
                path: `Persona/GetPersona/${id}`
            })
            return respuesta.nombres + (respuesta.segundoNombre == "" ? " " : respuesta.segundoNombre + " ") + respuesta.apellidos + " " + (respuesta.segundoApellido == "" ? " " : respuesta.segundoApellido);
        },

        async obtenerCompetenciaId(idCompetencia) {
            let respuesta = await this.$store.dispatch("hl_get", {
                path: `Competencia/GetCompetencia/${idCompetencia}`
            })
            return respuesta.titulo;
        },


        getBadgeClass(accion) {
            switch (accion) {
                case 'INSERT': return 'badge-insert';
                case 'UPDATE': return 'badge-update';
                case 'DELETE': return 'badge-delete';
                default: return '';
            }
        },

        getBadgeIcon(accion) {
            switch (accion) {
                case 'INSERT': return 'fas fa-plus';
                case 'UPDATE': return 'fas fa-pen';
                case 'DELETE': return 'fas fa-trash';
                default: return 'fas fa-question';
            }
        },

        getBadgeVariant(accion) {
            switch (accion) {
                case 'INSERT': return 'badge-success';
                case 'UPDATE': return 'badge-primary';
                case 'DELETE': return 'badge-danger';
                default: return 'badge-secondary';
            }
        },

        accionesHechas(accion) {
            switch (accion) {
                case 'INSERT': return 'Agregado';
                case 'UPDATE': return 'Actualización';
                case 'DELETE': return 'Eliminado';
                default: return 'badge-secondary';
            }
        },
        abrirModalDescripcion(id, descripcion) {
            console.log("El id es:", id);
            this.idCambio = id
            this.descripcionCambio = descripcion
            this.$bvModal.show("modalDescripcionCambio");
        },
        async guardarDescripcion() {
            let respuesta = await this.$store.dispatch("hl_put", {
                path: `HistorialCambiosPerfilCargo/ActualizarDescHistorialCambiosPerfilCargo/${this.idCambio}`,
                data: this.descripcionCambio
            })
            if (respuesta.success == true) {
                Swal.fire({
                    title: 'Descripción agregada',
                    text: 'La descripción ha sido agregada',
                    icon: "success"
                })
                this.descripcionCambio = null
                this.$emit('actualizarData')
                return respuesta
            }
            else {
                Swal.fire({
                    title: 'Descripción agregada',
                    text: 'La descripción ha sido agregada',
                    icon: "success"
                })
                return 'Error';
            }


        }

    }
}
</script>

<style scoped>
.timeline {
    position: relative;
    padding: 1rem;
}

.timeline-item {
    position: relative;
    margin-bottom: 1.5rem;
    padding-left: 2.5rem;
}

.timeline-badge {
    position: absolute;
    left: 0;
    top: 0.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 1;
}

.badge-insert {
    background-color: #28a745;
}

.badge-update {
    background-color: #007bff;
}

.badge-delete {
    background-color: #dc3545;
}

.timeline-card {
    margin-left: 0.5rem;
    border-radius: 0.25rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.border-left-insert {
    border-left: 4px solid #28a745 !important;
}

.border-left-update {
    border-left: 4px solid #007bff !important;
}

.border-left-delete {
    border-left: 4px solid #dc3545 !important;
}

.change-field {
    min-width: 120px;
}

@media (max-width: 768px) {
    .timeline-item {
        padding-left: 2rem;
    }

    .timeline-badge {
        width: 1.5rem;
        height: 1.5rem;
        font-size: 0.75rem;
    }

    .change-field {
        min-width: 100px;
    }
}
</style>